<template>
  <svg :class="svgClass" aria-hidden="true" :style="{backgroundColor:bgcolor}">
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    bgcolor:'',
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 48px;
  height: 36.7px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>